import { render } from "./Holiday.vue?vue&type=template&id=42151e5a&scoped=true"
import script from "./Holiday.vue?vue&type=script&lang=js"
export * from "./Holiday.vue?vue&type=script&lang=js"

import "./Holiday.vue?vue&type=style&index=0&id=42151e5a&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42151e5a"]])

export default __exports__